import { Button, Container, Image } from "react-bootstrap";

import notfound from "../../imgs/404.png"
import "./style.scss"

export const NotFound = () => {
    return (
        <Container className="notfound">
            <Image src={notfound} />
            <div className="info">
                <div className="text">The page has been remmoved or the URL is not correct.</div>
                <Button href="https://laropay.net">Back to Home</Button>
            </div>
        </Container>
    );
}